import React, { useEffect, useState, createContext, useContext } from 'react';
// Define user type
type User = {
  username: string;
  role: string;
};
// Define context type
type AuthContextType = {
  user: User | null;
  login: (username: string, password: string) => Promise<boolean>;
  logout: () => void;
  forgotPassword: (email: string) => Promise<boolean>;
};
// Create context
const AuthContext = createContext<AuthContextType | undefined>(undefined);
// Auth provider component
export const AuthProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [user, setUser] = useState<User | null>(null);
  // Check for existing user session on load
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);
  // Login function
  const login = async (username: string, password: string): Promise<boolean> => {
    // In a real app, this would be an API call
    // For this demo, we'll just check against our hardcoded users
    if ((username === 'adminmaker' || username === 'adminchecker') && password === 'Test@1234') {
      const userData = {
        username,
        role: username === 'adminmaker' ? 'maker' : 'checker'
      };
      setUser(userData);
      localStorage.setItem('user', JSON.stringify(userData));
      return true;
    }
    return false;
  };
  // Logout function
  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };
  // Forgot password function
  const forgotPassword = async (email: string): Promise<boolean> => {
    // In a real app, this would trigger a password reset email
    // For this demo, we'll just return true after a delay
    return new Promise(resolve => {
      setTimeout(() => resolve(true), 1000);
    });
  };
  return <AuthContext.Provider value={{
    user,
    login,
    logout,
    forgotPassword
  }} data-id="element-246">
      {children}
    </AuthContext.Provider>;
};
// Custom hook to use auth context
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};